// TODO 계속 보완 필요
import { IS_CLIENT } from '@repo/common-utils';

export type CorporationRefundData = {
  authType?: 'hometax' | 'joint-certificate';
  serviceAgreementFlow: boolean;
  marketingAgree?: boolean;
  thirdAgree?: boolean;
  refundToken?: string;
  refundId?: string;
  refundAmount?: string;
  refundStatus?: string;
  bizName?: string;
  tin?: string;
  regNo?: never;

  // 계좌입력 정보
  bank?: string;
  accountNo?: string;
  accountOwner?: string;

  // 제휴사 할인 정보
  partnerName?: string;
  feeRate?: string;
  defaultFeeRate?: string;

  // 홈택스 아이디 입력 화면 자동 채우기를 위한 필드
  hometaxId?: string;
};

const corporationRefundDataKey = 'corporationRefundData';

export function initCorporationRefundData() {
  if (IS_CLIENT) {
    sessionStorage.removeItem(corporationRefundDataKey);
  }
}

export function getCorporationRefundData(): CorporationRefundData | undefined {
  if (IS_CLIENT) {
    const item = sessionStorage.getItem(corporationRefundDataKey);
    if (item) {
      return JSON.parse(item);
    }
  }

  return undefined;
}

export function setCorporationRefundData(data: CorporationRefundData) {
  if (IS_CLIENT) {
    sessionStorage.setItem(corporationRefundDataKey, JSON.stringify(data));
  }
}
